import { IconButton, InputAdornment } from '@mui/material';
import { Lock, LockOpen } from '@mui/icons-material';

type Props = {
    locked: boolean;
    fieldLabel: string;
    onToggle: () => void;
};

/*
    The padlock beside an SEO field. A locked field follows the course, so the SEO title tracks the
    course title and the canonical URL tracks the SEO title. Unlocking one lets an admin write it by
    hand, and it then stops following.
*/
export default function SeoLockToggle({ locked, fieldLabel, onToggle }: Props) {
    return (
        <InputAdornment position="end">
            <IconButton
                onClick={onToggle}
                size="small"
                aria-label={locked ? `Unlock ${fieldLabel}` : `Lock ${fieldLabel}`}
            >
                {locked ? <Lock fontSize="small" /> : <LockOpen fontSize="small" />}
            </IconButton>
        </InputAdornment>
    );
}
